import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 rounded-full bg-background-200">
          <i className="ri-movie-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-3">
          页面未找到
        </h1>
        <p className="text-foreground-500 mb-8">
          您要查找的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}